import { jsx as _jsx } from "react/jsx-runtime";
// https://www.npmjs.com/package/rc-table
import Pagination from 'rc-pagination';
import styled from 'styled-components';
import Icon from '@/components/base/Icon';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PaginationLayout = styled.div.withConfig({
    displayName: "Pagination__PaginationLayout",
    componentId: "sc-1elorz3-0"
})([
    ".ex-pagination{",
    " &-item{",
    " &-active{",
    "}}&-jump-next span,&-jump-prev span{",
    "}&-prev{",
    "}&-next{",
    "}&-next,&-prev{",
    "}&-disabled *{",
    "}.more{display:inline-block;transform:translateY(-5px);}}"
], {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "30px"
}, {
    "fontSize": "14px",
    "lineHeight": "18px",
    "paddingLeft": "10px",
    "paddingRight": "10px",
    "color": "var(--color-desc-text)",
    "minWidth": "34px",
    "height": "34px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginLeft": "2.5px",
    "marginRight": "2.5px",
    "borderRadius": "4px",
    "borderColor": "var(--color-border)",
    "borderWidth": "1px",
    "cursor": "pointer"
}, {
    "backgroundColor": "var(--color-text-primary)",
    "color": "var(--color-text-other)",
    "borderColor": "var(--color-text-primary)"
}, {
    "marginLeft": "14px",
    "marginRight": "14px",
    "color": "var(--color-desc-text)",
    "fontSize": "20px",
    "cursor": "pointer"
}, {
    "marginRight": "10px"
}, {
    "marginLeft": "10px"
}, {
    "opacity": "0.6",
    "cursor": "pointer"
}, {
    "cursor": "not-allowed",
    "color": "var(--color-desc-text)"
});
export default function CustomPagination(props) {
    var onPageChange = props.onPageChange, rest = _objectWithoutProperties(props, [
        "onPageChange"
    ]);
    return(/*#__PURE__*/ _jsx(PaginationLayout, {
        children: /*#__PURE__*/ _jsx(Pagination, _objectSpread({
            prevIcon: /*#__PURE__*/ _jsx(Icon, {
                type: "left"
            }),
            nextIcon: /*#__PURE__*/ _jsx(Icon, {
                type: "right"
            }),
            jumpPrevIcon: /*#__PURE__*/ _jsx("span", {
                className: "more",
                children: "..."
            }),
            jumpNextIcon: /*#__PURE__*/ _jsx("span", {
                className: "more",
                children: "..."
            })
        }, rest, {
            prefixCls: "ex-pagination",
            onChange: onPageChange
        }))
    }));
};
